// extracted by mini-css-extract-plugin
export default {"role":"eSR5C5"};